import request from '@/utils/request'
import qs from 'qs'

// 列表
export const getNewsList = (params) => {
  return request({
    url: '/api/news',
    method: 'GET',
    params: params,
    paramsSerializer: params => {
      return qs.stringify(params, {indices: false})
    }
  })
}

//新增资讯
export const addNews = (params) => {
    return request({
      url: '/api/news',
      method: 'POST',
      data: params
    })
}

//新增资讯
export const editNews = (params) => {
  return request({
    url: '/api/news',
    method: 'PUT',
    data: params
  })
}
// 删除资讯
export const deleteNews = (id) => {
    return request({
      url: '/api/news/' + id,
      method: 'DELETE',
    })
}
// 发布资讯
export const pushNews = (id) => {
    return request({
      url: '/api//news/publish/' + id,
      method: 'PUT',
    })
}

// 取消发布资讯
export const cancelPushNews = (id) => {
    return request({
      url: '/api/news/cancelpublish/' + id,
      method: 'PUT',
    })
}

// 获取资讯详情
export const getNewsDetail = (id) => {
  return request({
    url: '/api/news/' + id,
    method: 'GET',
  })
}